import RenameInput from './rename-input'
export default RenameInput
